module.exports = __webpack_public_path__ + "img/single-post-img3-800x527.72dc03b3.jpg";